import { Col, Row } from 'antd';
import { useEffect } from 'react';
/**
 *
 * @returns
 */
export const BaseContainer = ({ height = undefined, width = undefined, borderColor = undefined, backgroundColor = undefined, backgroundImg = '', children, marginTop = true, marginRight = true, marginBottom = true, marginLeft = true, scroll = undefined, minHeight = undefined, alignItems = undefined }) => {
  let style = {
    height: height || '',
    width: width || ''
  };

  if (borderColor) {
    style = { ...style, border: `1px solid ${borderColor}` };
  }
  if (backgroundColor) {
    style = { ...style, backgroundColor };
  }
  if (backgroundImg) {
    style = { ...style, background: `url(${backgroundImg}) 50% 50% / contain no-repeat` };
  }
  if (!marginTop) {
    style = { ...style, marginTop: '0px' };
  }
  if (!marginRight) {
    style = { ...style, marginRight: '0px' };
  }
  if (!marginBottom) {
    style = { ...style, marginBottom: '0px' };
  }
  if (!marginLeft) {
    style = { ...style, marginLeft: '0px' };
  }
  if (scroll) {
    style = { ...style, ...scroll };
  }
  if (minHeight) {
    style = { ...style, minHeight: minHeight };
  }
  // if (alignItems) {
  //   style = { ...style, alignItems: `${alignItems} !important` };
  // }

  return (
    <Row className={`component-container ${alignItems}`} style={{ ...style }}>
      <Col span={24}>{children}</Col>
    </Row>
  );
};
